import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkEmailCopyToIsAllowedRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const emailCopyTo = control.get('emailCopyTo')!.value;
	const emailReceipt = control.get('emailReceipt')!.value;
	return !!emailCopyTo && !emailReceipt ? { checkEmailRecipientFlag: true } : null;
};
